  import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { ComponentDocument } from '../../components/signer/ComponentDocument';
import { ComponentAsideDefault } from '../../components/signer/ComponentAsideDefault';
import { ComponentAlerts } from '../../components/signer/ComponentAlerts';
import ModalSeleccionarApariencia from '../../components/signer/modal/ModalSeleccionarApariencia';
import ModalDefinirApariencia from './../../components/signer/modal/ModalDefinirApariencia';
  import {PDFStatusContext, PDFStatusProvider} from "../../context/PDFStatusContext";


export const SignDocument = ({ fileName }) => {
    const location = useLocation();
    const { alertType, alertMessageKey } = location.state || {};
    const [blockMessage, setBlockMessage] = useState('');
    const { pdfNotProtected } = useContext(PDFStatusContext);
    const modalDefinirRef = useRef(null);

    useEffect(() => {
        const isBlocked = sessionStorage.getItem('browserBlocked') === '1';
        const msg = sessionStorage.getItem('browserBlockMessage') || '';
        setBlockMessage(isBlocked ? msg : '');
    }, []);

    // Componente interno que SI puede usar el contexto (está dentro del Provider)
    const DocProtectionAlert = () => {
    const { pdfNotProtected } = useContext(PDFStatusContext);
    if (pdfNotProtected) return null; // solo mostramos cuando está PROTEGIDO
    return (
      <ComponentAlerts
        alertType="warning"
        rawMessage="Este documento está protegido. No es posible continuar el proceso de firma."
      />
      );
    };

    return (
        <>
            <main className="main-content main-grid">
                <PDFStatusProvider>
                <div>
                    {/* Warning por versión mínima del navegador */}
                    <DocProtectionAlert />
                    {blockMessage && (
                        <ComponentAlerts
                            alertType="warning"
                            rawMessage={blockMessage}
                        />
                    )}
                    {alertType && alertMessageKey && (
                        <ComponentAlerts alertType={alertType} alertMessageKey={alertMessageKey} />
                    )}
                    <ComponentDocument fileName={fileName} />
                </div>
                <div>
                    <ComponentAsideDefault modalDefinirRef={modalDefinirRef} />
                </div>
                </PDFStatusProvider>
            </main>
            <ModalSeleccionarApariencia />
            <ModalDefinirApariencia ref={modalDefinirRef} />
        </>
    );
};
